import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingModule } from './landing/landing.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { AuthGuard } from './auth.guard';
import { CustomerConsentComponent } from './customer-consent/customer-consent.component';
import { LoadingComponent } from './dashboard/loading/loading.component';
import { EntityMailConsentComponent } from './entity-mail-consent/entity-mail-consent.component';
import { SiMailConsentComponent } from './si-mail-consent/si-mail-consent.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],  // Move this inside the loadChildren object
  },
  {
    path: 'consent',
    component: CustomerConsentComponent,
  },
  {
    path: 'entityConsent',
    component: EntityMailConsentComponent,
  },
  {
    path: 'siConsent',
    component: SiMailConsentComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
  {
    path: 'loading',
    component: LoadingComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
